import page from 'page'
import { parse, stringify } from 'query-string'
// import config.js from the root directory
import { config } from '../config.js'
// import { serverUrl } from './stores.js';

import { dbAPI, user } from './stores.js'


const ENV = config.ENV
const AUTH_URL = config.AUTH_URL
// check if SESSION storage has a serverUrl
export const API_URL_LIST = config.API_URL_LIST
let API_URL = '';
let api_id = -1;
// make sure API_URL is in sync with dbAPI.url
dbAPI.subscribe(value => {
  console.log('API_URL:::', JSON.stringify(API_URL));
  console.log('API_URL::: VALUE', JSON.stringify(value));
  API_URL = value.url;
  api_id = value.id;
  console.log('API_URL:::', JSON.stringify(API_URL));
})

// let API_URL = sessionStorage.getItem('serverUrl')? sessionStorage.getItem('serverUrl'): config.API_URL
// serverUrl? serverUrl: config.API_URL




function isIntegerString(x) {
  return +x === +x && ! x.includes('.')
}

export function getActiveElementNoBody() {
  // Body might be returned of no element is active; we 
  // would want null.
  const activeElement = document.activeElement
  console.log(`activeElement: ${activeElement}`)
  return (document.body === activeElement)
         ? null
         : activeElement
}

// function getApiPort() {
//   // return parse(location.search)['apiport']
//   return '5000'
// }

export function getLocalPathWithQuery(path, params={}) {
  // Add apiport value to query string if currently set.
  // const apiport = getApiPort()
  // if (apiport) {
  //   params.apiport = apiport
  // }
  const query = stringify(params)
  const pathq = path + '?' + query
  return pathq
}

export function showPage(path, params={}) {
  const pathq = getLocalPathWithQuery(path, params)
  page.show(pathq)
}

export function redirectToPage(path, params={}) {
  const pathq = getLocalPathWithQuery(path, params)
  // console.log(`redirectToPage: ${pathq}`)
  page.redirect('/'+pathq)
}

// export function getApiUrlBase() {

//   //let apiport = (new URLSearchParams(location.search)).get('apiport')
//   const apiport = getApiPort()
//   if (!apiport) {
//     return ''
//   } else {
//     if (isIntegerString(apiport)) {
//       const urlbase = `${location.protocol}//` +
//                       `${location.hostname}:${apiport}`
//       return urlbase
//     } else {
//       alert('apiport must be an integer')
//       throw 'apiport must be an integer'
//     }
//   }
// }

export function getApiUrl(apipath, params, prefix='api') {
  const urlbase = prefix === 'api' ? API_URL : AUTH_URL
  let apipathprefix = prefix
  if (ENV === 'production') {
    apipathprefix = prefix === 'api' ? `api${api_id}` : prefix;
  }
  const path = apipathprefix + '/' + apipath
  let url = `${urlbase}/${path}`
  const query = stringify(params)
  if (query) {
    url += '?' + query
  }
  return url
}

let userinfo;
user.subscribe(value => {
  userinfo = value
})

export function fetchWithSession(url, options) {
  // redirect to /login if user.isAuth is not true
  // console.log("fetchWithSession User", userinfo)
  if (!userinfo.isAuth && !url === 'validate-session') {
    console.error("Not Authenticated")
    return
  }

  console.log ("fetchWithSession", API_URL)
  console.log(`fetchWithSession: ${url}`)
  // set the credentials option to "include" in the options object
  const newOptions = {
    ...options,
    credentials: 'include'
  };

  // call the original fetch function with the modified options object
  return fetch(url, newOptions);
}